<template>
    <div>
        <div style="width: 1160px;margin: 10px auto;background-color: #ffffff;min-height: 700px;padding: 20px 20px;">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm" style="width: 80%;margin: 30px auto;">
                <el-form-item label="订单编号">
                    <el-input v-model="ruleForm.orderNo" disabled></el-input>
                </el-form-item>
               
                <el-form-item label="快递公司" prop="expressCompany">
                    <el-radio-group v-model="ruleForm.expressCompany">
                        <el-radio v-for="item,index in expressData" :key="index" :label="item.dict_value">
                            {{ item.dict_label }}
                        </el-radio>
                        <!-- <el-radio label="线下场地免费"></el-radio> -->
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="快递单号" prop="trackingNumber">
                    <el-input v-model="ruleForm.trackingNumber" placeholder="请填写快递单号"></el-input>
                </el-form-item>
                <el-form-item label="备注">
                    <el-input type="textarea" v-model="ruleForm.desc" placeholder="请填写备注"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="submitForm('ruleForm')">确认并提交</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
  export default {
    data() {
      return {
        expressData: [],
        ruleForm: {
            orderNo: '',
            trackingNumber: '',
            expressCompany: '',
            desc: ''
        },
        rules: {
           
            trackingNumber: [
                { required: true, message: '请填写快递单号', trigger: 'blur' }
            ],
          
            expressCompany: [
                { required: true, message: '请选择快递公司', trigger: 'change' }
            ],
           
        }
      };
    },
    created(){
       this.ruleForm.orderNo = this.$route.query.orderOn

       let data = {
         pageSize: 999
       }

       this.$store.dispatch('personal/dictExpressList',data)
          .then(res => {
            if(res.ok){
                this.expressData = []
                this.expressData = res.data.items
            }
          })
    },
    methods: {
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            var name = ''
            this.expressData.forEach(item => {
                if(item.dict_value == this.ruleForm.expressCompany){
                    name = item.dict_label
                }
            });
           let data = {
                order_no: this.ruleForm.orderNo,
                express_value: this.ruleForm.expressCompany,
                express_name: name,
                express_no: this.ruleForm.trackingNumber,
                remark: this.ruleForm.desc
           }
           console.log(data);
           this.$store.dispatch('personal/orderExpressAdd',data)
                .then(res => {
                    if(res.ok){
                        this.$notify({
                            title: '提示',
                            message: '发货成功',
                            type: 'success'
                        })
                       this.$router.go(-1)
                    }
                })
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      }
    }
  }
</script>